import { Colors } from "assets/colors";

export const styles: any = {
  bar: {
    width: "71px", 
    height: "100vh", 
    left: 0,
    backgroundColor: "white"
  },
  toolbar: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingTop: "2rem",
    "&:hover": {
      backgroundColor: "inherit"
    }
  },
  drawerIcon: {
    color: Colors.LightBlue,
    marginTop: "1.5rem",
    backgroundColor: Colors.BlueIconBox,
    padding: ".5rem",
    fontSize: "2.5rem",
    borderRadius: "5px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: Colors.DarkGrayIconBox,
      borderRadius: "50%",
      transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    }
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "1.5rem .5rem"
  },
  content: {
    backgroundColor: Colors.BackgroundGray,
    height: "100vh",
    padding: "1rem",
    maxWidth: "100vw",
    overflowX: "auto"
  },
  headerText: {
    fontSize: ".75rem",
    color: Colors.LightBlueText,
    fontWeight: 600
  },
  contentContainer: {
    padding: "1rem 1.5rem",
    width: "100%"
  },
  activeLink: {
    backgroundColor: Colors.Green,
    color: "white",
    padding: ".5rem 1rem",
    cursor: "pointer",
    borderRadius: "5px",
    textDecoration: "none",
    width: "100%",
    margin: ".5rem 0",
    display: "flex",
    fontSize: ".875rem",
  },
  link: {
    color: Colors.BlackText,
    padding: ".5rem 1rem",
    cursor: "pointer",
    borderRadius: "5px",
    textDecoration: "none",
    width: "100%",
    margin: ".5rem 0",
    display: "flex",
    fontSize: ".875rem",
  }
} 
